import React, { useEffect } from 'react';

const StripeDebug: React.FC = () => {
  useEffect(() => {
    // console.log('Stripe Environment Variables:');
    // console.log('REACT_APP_STRIPE_PUBLIC_KEY:', process.env.REACT_APP_STRIPE_PUBLIC_KEY || 'Not set');
    // console.log('REACT_APP_STRIPE_PRICE_ID:', process.env.REACT_APP_STRIPE_PRICE_ID || 'Not set');
  }, []);

  return null; // This component doesn't render anything
};

export default StripeDebug;
